module.exports = __webpack_public_path__ + "static/media/FOXPAY.b46f0f2b.svg";